import { InventoryDisclaimer } from '../types/main';

export enum DisclaimerKeys {
  LandingKey = 'landing',
  ResultsKey = 'results',
  DetailsKey = 'details',
}

/**
 * Get all the disclaimers of a page (landing, results, details)
 * @param pageName
 * @param disclaimers
 */
export const getDisclaimersByPage = (
  pageName: string,
  disclaimers?,
): InventoryDisclaimer[] | undefined => {
  if (!disclaimers) return;

  return disclaimers?.filter((disclaimer) => disclaimer.pageName === pageName);
};
